import { assetCategoryColors } from '@savvy/deprecated-shared/theme/asset-category-colors';

// These values need to correlate with the values coming from Orion
// TODO: We should just return an asset category enum from graphql directly
export const enum ASSET_CATEGORY {
  EQUITY = 'Equity',
  FIXED_INCOME = 'Fixed Income',
  ALTERNATIVES = 'Alternatives',
  CASH = 'Cash', // Sandbox Value
  CASH_AND_CASH_EQUIVALENTS = 'Cash & Cash Equivalents', // Production value
  MULTI_ASSET_STRATEGY = 'Multi-Asset Strategy',
}

// These values are only used for the empty state of the household overview. They are display only and do not need to correlate with Orion values.
export const ASSET_CATEGORIES_FOR_HOUSEHOLD_OVERVIEW = [
  ASSET_CATEGORY.EQUITY,
  ASSET_CATEGORY.FIXED_INCOME,
  ASSET_CATEGORY.ALTERNATIVES,
  ASSET_CATEGORY.CASH,
];

// TODO: We should use the generated enum graphql types instead
export const ASSET_CATEGORY_COLOR_MAP = {
  [ASSET_CATEGORY.EQUITY]: assetCategoryColors.equity,
  [ASSET_CATEGORY.FIXED_INCOME]: assetCategoryColors.fixedIncome,
  [ASSET_CATEGORY.ALTERNATIVES]: assetCategoryColors.alternatives,
  [ASSET_CATEGORY.CASH]: assetCategoryColors.cash,
  [ASSET_CATEGORY.CASH_AND_CASH_EQUIVALENTS]: assetCategoryColors.cash,
  [ASSET_CATEGORY.MULTI_ASSET_STRATEGY]: assetCategoryColors.multiAssetStrategy,
};
